import * as ws_base from '../ws/ws_base'

const DOMINIO = "imagem_pedido";


export async function salvarImagemPedido(id_pedido, imagem){

	return await ws_base.upload(DOMINIO, "salvar", {"id_pedido": id_pedido}, imagem);
}
